export class AggiornaPasswordModel {
  username: string;
  password: string;
  newPassword: string;
}